var E;
// @__NO_SIDE_EFFECTS__
function Se(t) {
  return {
    lang: (t == null ? void 0 : t.lang) ?? (E == null ? void 0 : E.lang),
    message: t == null ? void 0 : t.message,
    abortEarly: (t == null ? void 0 : t.abortEarly) ?? (E == null ? void 0 : E.abortEarly),
    abortPipeEarly: (t == null ? void 0 : t.abortPipeEarly) ?? (E == null ? void 0 : E.abortPipeEarly)
  };
}
var U;
// @__NO_SIDE_EFFECTS__
function ct(t) {
  return U == null ? void 0 : U.get(t);
}
var O;
// @__NO_SIDE_EFFECTS__
function pt(t) {
  return O == null ? void 0 : O.get(t);
}
var J;
// @__NO_SIDE_EFFECTS__
function lt(t, e) {
  var n;
  return (n = J == null ? void 0 : J.get(t)) == null ? void 0 : n.get(e);
}
// @__NO_SIDE_EFFECTS__
function ft(t) {
  var n, r;
  const e = typeof t;
  return e === "string" ? `"${t}"` : e === "number" || e === "bigint" || e === "boolean" ? `${t}` : e === "object" || e === "function" ? (t && ((r = (n = Object.getPrototypeOf(t)) == null ? void 0 : n.constructor) == null ? void 0 : r.name)) ?? "null" : e;
}
function A(t, e, n, r, s) {
  const o = s && "input" in s ? s.input : n.value, i = (s == null ? void 0 : s.expected) ?? t.expects ?? null, a = (s == null ? void 0 : s.received) ?? /* @__PURE__ */ ft(o), u = {
    kind: t.kind,
    type: t.type,
    input: o,
    expected: i,
    received: a,
    message: `Invalid ${e}: ${i ? `Expected ${i} but r` : "R"}eceived ${a}`,
    requirement: t.requirement,
    path: s == null ? void 0 : s.path,
    issues: s == null ? void 0 : s.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, c = t.kind === "schema", p = (s == null ? void 0 : s.message) ?? t.message ?? /* @__PURE__ */ lt(t.reference, u.lang) ?? (c ? /* @__PURE__ */ pt(u.lang) : null) ?? r.message ?? /* @__PURE__ */ ct(u.lang);
  p && (u.message = typeof p == "function" ? (
    // @ts-expect-error
    p(u)
  ) : p), c && (n.typed = !1), n.issues ? n.issues.push(u) : n.issues = [u];
}
// @__NO_SIDE_EFFECTS__
function w(t) {
  return {
    version: 1,
    vendor: "valibot",
    validate(e) {
      return t["~run"]({ value: e }, /* @__PURE__ */ Se());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function dt(t, e) {
  return Object.hasOwn(t, e) && e !== "__proto__" && e !== "prototype" && e !== "constructor";
}
var yt = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(t) {
    super(t[0].message), this.name = "ValiError", this.issues = t;
  }
};
// @__NO_SIDE_EFFECTS__
function ee(t, e, n) {
  return typeof t.default == "function" ? (
    // @ts-expect-error
    t.default(e, n)
  ) : (
    // @ts-expect-error
    t.default
  );
}
// @__NO_SIDE_EFFECTS__
function W(t, e) {
  return !t["~run"]({ value: e }, { abortEarly: !0 }).issues;
}
// @__NO_SIDE_EFFECTS__
function je() {
  return {
    kind: "schema",
    type: "any",
    reference: je,
    expects: "any",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(t) {
      return t.typed = !0, t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function B(t) {
  return {
    kind: "schema",
    type: "boolean",
    reference: B,
    expects: "boolean",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      return typeof e.value == "boolean" ? e.typed = !0 : A(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function te(t) {
  return {
    kind: "schema",
    type: "function",
    reference: te,
    expects: "Function",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      return typeof e.value == "function" ? e.typed = !0 : A(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function g(t, e) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: g,
    expects: "Object",
    async: !1,
    entries: t,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(n, r) {
      var o;
      const s = n.value;
      if (s && typeof s == "object") {
        n.typed = !0, n.value = {};
        for (const i in this.entries) {
          const a = this.entries[i];
          if (i in s || (a.type === "exact_optional" || a.type === "optional" || a.type === "nullish") && // @ts-expect-error
          a.default !== void 0) {
            const u = i in s ? (
              // @ts-expect-error
              s[i]
            ) : /* @__PURE__ */ ee(a), c = a["~run"]({ value: u }, r);
            if (c.issues) {
              const p = {
                type: "object",
                origin: "value",
                input: s,
                key: i,
                value: u
              };
              for (const l of c.issues)
                l.path ? l.path.unshift(p) : l.path = [p], (o = n.issues) == null || o.push(l);
              if (n.issues || (n.issues = c.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            c.typed || (n.typed = !1), n.value[i] = c.value;
          } else if (a.type !== "exact_optional" && a.type !== "optional" && a.type !== "nullish" && (A(this, "key", n, r, {
            input: void 0,
            expected: `"${i}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: s,
                key: i,
                // @ts-expect-error
                value: s[i]
              }
            ]
          }), r.abortEarly))
            break;
        }
        if (!n.issues || !r.abortEarly)
          for (const i in s)
            /* @__PURE__ */ dt(s, i) && !(i in this.entries) && (n.value[i] = s[i]);
      } else
        A(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function T(t, e) {
  return {
    kind: "schema",
    type: "nullish",
    reference: T,
    expects: `(${t.expects} | null | undefined)`,
    async: !1,
    wrapped: t,
    default: e,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(n, r) {
      return (n.value === null || n.value === void 0) && (this.default !== void 0 && (n.value = /* @__PURE__ */ ee(this, n, r)), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function F(t) {
  return {
    kind: "schema",
    type: "number",
    reference: F,
    expects: "number",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      return typeof e.value == "number" && !isNaN(e.value) ? e.typed = !0 : A(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function K(t, e) {
  return {
    kind: "schema",
    type: "optional",
    reference: K,
    expects: `(${t.expects} | undefined)`,
    async: !1,
    wrapped: t,
    default: e,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(n, r) {
      return n.value === void 0 && (this.default !== void 0 && (n.value = /* @__PURE__ */ ee(this, n, r)), n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function k(t) {
  return {
    kind: "schema",
    type: "string",
    reference: k,
    expects: "string",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      return typeof e.value == "string" ? e.typed = !0 : A(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ae() {
  return {
    kind: "schema",
    type: "unknown",
    reference: Ae,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(t) {
      return t.typed = !0, t;
    }
  };
}
function Y(t, e, n) {
  const r = t["~run"]({ value: e }, /* @__PURE__ */ Se(n));
  if (r.issues)
    throw new yt(r.issues);
  return r.value;
}
// @__NO_SIDE_EFFECTS__
function qe(...t) {
  return {
    ...t[0],
    pipe: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      for (const r of t)
        if (r.kind !== "metadata") {
          if (e.issues && (r.kind === "schema" || r.kind === "transformation")) {
            e.typed = !1;
            break;
          }
          (!e.issues || !n.abortEarly && !n.abortPipeEarly) && (e = r["~run"](e, n));
        }
      return e;
    }
  };
}
function Me(t) {
  return /* @__PURE__ */ W(
    /* @__PURE__ */ g({ TelegramWebviewProxy: /* @__PURE__ */ g({ postEvent: /* @__PURE__ */ te() }) }),
    t
  );
}
function Te() {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}
var _t = Object.defineProperty, bt = (t, e, n) => e in t ? _t(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, H = (t, e, n) => bt(t, typeof e != "symbol" ? e + "" : e, n);
function ht(t) {
  return (e) => e instanceof t;
}
function Ie(t, e) {
  e || (e = []);
  class n extends Error {
    constructor(...s) {
      const o = typeof e == "function" ? e(...s) : typeof e == "string" ? [e] : e || [];
      super(...o), this.name = t;
    }
  }
  return Object.defineProperty(n, "name", { value: t }), [n, ht(n)];
}
const [mt, bn] = Ie("CancelledError", "Promise was canceled"), [vt, hn] = Ie(
  "TimeoutError",
  (t, e) => [`Timeout reached: ${t}ms`, { cause: e }]
), Le = Symbol("Resolved");
function ye(t) {
  return Array.isArray(t) && t[0] === Le;
}
function gt(t) {
  return [Le, t];
}
function _e(t, e) {
  return t.reject = e.reject, t.abort = e.abort, t;
}
let ne = class Q extends Promise {
  constructor(e, n) {
    let r, s;
    super((o, i) => {
      let a, u;
      typeof e == "function" ? (a = e, u = n) : u = e;
      const c = [], p = (f) => (...j) => {
        const R = f(...j);
        return c.forEach((ut) => ut()), R;
      }, l = new AbortController(), { signal: _ } = l;
      s = (f) => {
        !_.aborted && l.abort(f);
      };
      const b = () => _.reason, P = (f) => {
        const j = () => {
          f(b());
        };
        _.addEventListener("abort", j, !0);
        const R = () => {
          _.removeEventListener("abort", j, !0);
        };
        return c.push(R), R;
      }, at = p((f) => {
        o(f), s(gt(f));
      });
      r = p((f) => {
        i(f), s(f);
      }), u || (u = {});
      const { abortSignal: S, rejectOnAbort: pe = !0 } = u;
      if (S)
        if (S.aborted) {
          const { reason: f } = S;
          if (pe)
            return r(f);
          s(f);
        } else {
          const f = () => {
            s(S.reason);
          };
          S.addEventListener("abort", f), c.push(() => {
            S.removeEventListener("abort", f);
          });
        }
      pe && P(i);
      const { timeout: N } = u;
      if (N) {
        const f = setTimeout(() => {
          s(new vt(N));
        }, N);
        c.push(() => {
          clearTimeout(f);
        });
      }
      const le = () => _.aborted, fe = () => ye(b()), de = () => {
        const f = b();
        return ye(f) ? f[1] : void 0;
      };
      try {
        const f = a && a(at, r, {
          abortReason: b,
          abortSignal: _,
          isAborted: le,
          isResolved: fe,
          onAborted: P,
          onResolved: (j) => P(() => {
            fe() && j(de());
          }),
          resolved: de,
          throwIfAborted() {
            if (le())
              throw b();
          }
        });
        f instanceof Promise && f.catch(r);
      } catch (f) {
        r(f);
      }
    }), H(this, "abort"), H(this, "reject"), this.abort = s, this.reject = r;
  }
  /**
   * Creates a new AbortablePromise instance using an executor, resolving the promise when a result
   * was returned.
   * @param fn - function returning promise result.
   * @param options - additional options.
   */
  static fn(e, n) {
    return new Q(async (r, s, o) => {
      try {
        r(await e(o));
      } catch (i) {
        s(i);
      }
    }, n);
  }
  static resolve(e) {
    return this.fn(() => e);
  }
  /**
   * @see Promise.reject
   */
  static reject(e) {
    return new Q((n, r) => {
      r(e);
    });
  }
  /**
   * Aborts the promise with the cancel error.
   */
  cancel() {
    this.abort(new mt());
  }
  /**
   * @see Promise.catch
   */
  catch(e) {
    return this.then(void 0, e);
  }
  /**
   * @see Promise.finally
   */
  finally(e) {
    return _e(super.finally(e), this);
  }
  /**
   * @see Promise.then
   */
  then(e, n) {
    return _e(super.then(e, n), this);
  }
};
function be(t, e) {
  return t.resolve = e.resolve, t;
}
let mn = class Z extends ne {
  constructor(e, n) {
    let r, s;
    typeof e == "function" ? (r = e, s = n) : s = e;
    let o;
    super((i, a, u) => {
      o = i, r && r(i, a, u);
    }, s), H(this, "resolve"), this.resolve = o;
  }
  /**
   * Creates a new ManualPromise instance using an executor, resolving the promise when a result
   * was returned.
   * @param fn - function returning promise result.
   * @param options - additional options.
   */
  static fn(e, n) {
    return new Z((r, s, o) => {
      try {
        Promise.resolve(e(o)).then(r, s);
      } catch (i) {
        s(i);
      }
    }, n);
  }
  static resolve(e) {
    return this.fn(() => e);
  }
  /**
   * @see Promise.reject
   */
  static reject(e) {
    return new Z((n, r) => {
      r(e);
    });
  }
  /**
   * @see Promise.catch
   */
  catch(e) {
    return this.then(void 0, e);
  }
  /**
   * @see Promise.finally
   */
  finally(e) {
    return be(super.finally(e), this);
  }
  /**
   * @see Promise.then
   */
  then(e, n) {
    return be(super.then(e, n), this);
  }
};
function wt(t) {
  return t.replace(/_[a-z]/g, (e) => e[1].toUpperCase());
}
function Et(t) {
  return Object.entries(t).reduce((e, [n, r]) => (e[wt(n)] = r, e), {});
}
function X(t) {
  const e = Et(t);
  for (const n in e) {
    const r = e[n];
    r && typeof r == "object" && !(r instanceof Date) && (e[n] = Array.isArray(r) ? r.map(X) : X(r));
  }
  return e;
}
function Re(t) {
  return `tapps/${t}`;
}
function De(t, e) {
  sessionStorage.setItem(Re(t), JSON.stringify(e));
}
function kt(t) {
  const e = sessionStorage.getItem(Re(t));
  try {
    return e ? JSON.parse(e) : void 0;
  } catch {
  }
}
function xt(...t) {
  const e = t.flat(1);
  return [
    e.push.bind(e),
    () => {
      e.forEach((n) => {
        n();
      });
    }
  ];
}
// @__NO_SIDE_EFFECTS__
function $t(t, e) {
  e || (e = {});
  const {
    textColor: n,
    bgColor: r,
    shouldLog: s
  } = e, o = s === void 0 ? !0 : s, i = typeof o == "boolean" ? () => o : o;
  function a(u, c, ...p) {
    if (c || i()) {
      const l = "font-weight:bold;padding:0 5px;border-radius:5px";
      console[u](
        `%c${Intl.DateTimeFormat("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          fractionalSecondDigits: 3,
          timeZone: "UTC"
        }).format(/* @__PURE__ */ new Date())}%c / %c${t}`,
        `${l};background-color: lightblue;color:black`,
        "",
        `${l};${n ? `color:${n};` : ""}${r ? `background-color:${r}` : ""}`,
        ...p
      );
    }
  }
  return [a.bind(void 0, "log"), a.bind(void 0, "error")];
}
// @__NO_SIDE_EFFECTS__
function We(t) {
  return {
    lang: (t == null ? void 0 : t.lang) ?? void 0,
    message: t == null ? void 0 : t.message,
    abortEarly: (t == null ? void 0 : t.abortEarly) ?? void 0,
    abortPipeEarly: (t == null ? void 0 : t.abortPipeEarly) ?? void 0
  };
}
// @__NO_SIDE_EFFECTS__
function Pt(t, e) {
  var n;
  return (n = void 0) == null ? void 0 : n.get(e);
}
// @__NO_SIDE_EFFECTS__
function St(t) {
  var e, n;
  const r = typeof t;
  return r === "string" ? `"${t}"` : r === "number" || r === "bigint" || r === "boolean" ? `${t}` : r === "object" || r === "function" ? (t && ((n = (e = Object.getPrototypeOf(t)) == null ? void 0 : e.constructor) == null ? void 0 : n.name)) ?? "null" : r;
}
function m(t, e, n, r, s) {
  const o = s && "input" in s ? s.input : n.value, i = (s == null ? void 0 : s.expected) ?? t.expects ?? null, a = (s == null ? void 0 : s.received) ?? /* @__PURE__ */ St(o), u = {
    kind: t.kind,
    type: t.type,
    input: o,
    expected: i,
    received: a,
    message: `Invalid ${e}: ${i ? `Expected ${i} but r` : "R"}eceived ${a}`,
    requirement: t.requirement,
    path: s == null ? void 0 : s.path,
    issues: s == null ? void 0 : s.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, c = t.kind === "schema", p = (s == null ? void 0 : s.message) ?? t.message ?? /* @__PURE__ */ Pt(t.reference, u.lang) ?? (c ? (u.lang, void 0) : null) ?? r.message ?? (u.lang, void 0);
  p && (u.message = typeof p == "function" ? (
    // @ts-expect-error
    p(u)
  ) : p), c && (n.typed = !1), n.issues ? n.issues.push(u) : n.issues = [u];
}
// @__NO_SIDE_EFFECTS__
function v(t) {
  return {
    version: 1,
    vendor: "valibot",
    validate(e) {
      return t["~run"]({ value: e }, /* @__PURE__ */ We());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ce(t, e) {
  return Object.hasOwn(t, e) && e !== "__proto__" && e !== "prototype" && e !== "constructor";
}
// @__NO_SIDE_EFFECTS__
function jt(t, e) {
  const n = [...new Set(t)];
  return n.length > 1 ? `(${n.join(` ${e} `)})` : n[0] ?? "never";
}
var At = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(t) {
    super(t[0].message), this.name = "ValiError", this.issues = t;
  }
};
// @__NO_SIDE_EFFECTS__
function Ne(t, e) {
  return {
    kind: "validation",
    type: "check",
    reference: Ne,
    async: !1,
    expects: null,
    requirement: t,
    message: e,
    "~run"(n, r) {
      return n.typed && !this.requirement(n.value) && m(this, "input", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ue(t) {
  return {
    kind: "validation",
    type: "integer",
    reference: Ue,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: t,
    "~run"(e, n) {
      return e.typed && !this.requirement(e.value) && m(this, "integer", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function x(t) {
  return {
    kind: "transformation",
    type: "transform",
    reference: x,
    async: !1,
    operation: t,
    "~run"(e) {
      return e.value = this.operation(e.value), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Oe(t, e, n) {
  return typeof t.default == "function" ? (
    // @ts-expect-error
    t.default(e, n)
  ) : (
    // @ts-expect-error
    t.default
  );
}
// @__NO_SIDE_EFFECTS__
function qt(t, e) {
  return !t["~run"]({ value: e }, { abortEarly: !0 }).issues;
}
// @__NO_SIDE_EFFECTS__
function I(t) {
  return {
    kind: "schema",
    type: "boolean",
    reference: I,
    expects: "boolean",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(e, n) {
      return typeof e.value == "boolean" ? e.typed = !0 : m(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Je(t) {
  return {
    kind: "schema",
    type: "date",
    reference: Je,
    expects: "Date",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(e, n) {
      return e.value instanceof Date ? isNaN(e.value) ? m(this, "type", e, n, {
        received: '"Invalid Date"'
      }) : e.typed = !0 : m(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ze(t, e) {
  return {
    kind: "schema",
    type: "instance",
    reference: ze,
    expects: t.name,
    async: !1,
    class: t,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(n, r) {
      return n.value instanceof this.class ? n.typed = !0 : m(this, "type", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function re(t) {
  return {
    kind: "schema",
    type: "lazy",
    reference: re,
    expects: "unknown",
    async: !1,
    getter: t,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(e, n) {
      return this.getter(e.value)["~run"](e, n);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function q(t, e) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: q,
    expects: "Object",
    async: !1,
    entries: t,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(n, r) {
      var s;
      const o = n.value;
      if (o && typeof o == "object") {
        n.typed = !0, n.value = {};
        for (const i in this.entries) {
          const a = this.entries[i];
          if (i in o || (a.type === "exact_optional" || a.type === "optional" || a.type === "nullish") && // @ts-expect-error
          a.default !== void 0) {
            const u = i in o ? (
              // @ts-expect-error
              o[i]
            ) : /* @__PURE__ */ Oe(a), c = a["~run"]({ value: u }, r);
            if (c.issues) {
              const p = {
                type: "object",
                origin: "value",
                input: o,
                key: i,
                value: u
              };
              for (const l of c.issues)
                l.path ? l.path.unshift(p) : l.path = [p], (s = n.issues) == null || s.push(l);
              if (n.issues || (n.issues = c.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            c.typed || (n.typed = !1), n.value[i] = c.value;
          } else if (a.type !== "exact_optional" && a.type !== "optional" && a.type !== "nullish" && (m(this, "key", n, r, {
            input: void 0,
            expected: `"${i}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: o,
                key: i,
                // @ts-expect-error
                value: o[i]
              }
            ]
          }), r.abortEarly))
            break;
        }
        if (!n.issues || !r.abortEarly)
          for (const i in o)
            /* @__PURE__ */ Ce(o, i) && !(i in this.entries) && (n.value[i] = o[i]);
      } else
        m(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function C(t) {
  return {
    kind: "schema",
    type: "number",
    reference: C,
    expects: "number",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(e, n) {
      return typeof e.value == "number" && !isNaN(e.value) ? e.typed = !0 : m(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function y(t, e) {
  return {
    kind: "schema",
    type: "optional",
    reference: y,
    expects: `(${t.expects} | undefined)`,
    async: !1,
    wrapped: t,
    default: e,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(n, r) {
      return n.value === void 0 && (this.default !== void 0 && (n.value = /* @__PURE__ */ Oe(this, n, r)), n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ge(t, e, n) {
  return {
    kind: "schema",
    type: "record",
    reference: Ge,
    expects: "Object",
    async: !1,
    key: t,
    value: e,
    message: n,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(r, s) {
      var o, i;
      const a = r.value;
      if (a && typeof a == "object") {
        r.typed = !0, r.value = {};
        for (const u in a)
          if (/* @__PURE__ */ Ce(a, u)) {
            const c = a[u], p = this.key["~run"]({ value: u }, s);
            if (p.issues) {
              const _ = {
                type: "object",
                origin: "key",
                input: a,
                key: u,
                value: c
              };
              for (const b of p.issues)
                b.path = [_], (o = r.issues) == null || o.push(b);
              if (r.issues || (r.issues = p.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            const l = this.value["~run"](
              { value: c },
              s
            );
            if (l.issues) {
              const _ = {
                type: "object",
                origin: "value",
                input: a,
                key: u,
                value: c
              };
              for (const b of l.issues)
                b.path ? b.path.unshift(_) : b.path = [_], (i = r.issues) == null || i.push(b);
              if (r.issues || (r.issues = l.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            (!p.typed || !l.typed) && (r.typed = !1), p.typed && (r.value[p.value] = l.value);
          }
      } else
        m(this, "type", r, s);
      return r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function d(t) {
  return {
    kind: "schema",
    type: "string",
    reference: d,
    expects: "string",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(e, n) {
      return typeof e.value == "string" ? e.typed = !0 : m(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function he(t) {
  let e;
  if (t)
    for (const n of t)
      e ? e.push(...n.issues) : e = n.issues;
  return e;
}
// @__NO_SIDE_EFFECTS__
function se(t, e) {
  return {
    kind: "schema",
    type: "union",
    reference: se,
    expects: /* @__PURE__ */ jt(
      t.map((n) => n.expects),
      "|"
    ),
    async: !1,
    options: t,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(n, r) {
      let s, o, i;
      for (const a of this.options) {
        const u = a["~run"]({ value: n.value }, r);
        if (u.typed)
          if (u.issues)
            o ? o.push(u) : o = [u];
          else {
            s = u;
            break;
          }
        else
          i ? i.push(u) : i = [u];
      }
      if (s)
        return s;
      if (o) {
        if (o.length === 1)
          return o[0];
        m(this, "type", n, r, {
          issues: /* @__PURE__ */ he(o)
        }), n.typed = !0;
      } else {
        if ((i == null ? void 0 : i.length) === 1)
          return i[0];
        m(this, "type", n, r, {
          issues: /* @__PURE__ */ he(i)
        });
      }
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Be() {
  return {
    kind: "schema",
    type: "unknown",
    reference: Be,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(t) {
      return t.typed = !0, t;
    }
  };
}
function Fe(t, e, n) {
  const r = t["~run"]({ value: e }, /* @__PURE__ */ We(n));
  if (r.issues)
    throw new At(r.issues);
  return r.value;
}
// @__NO_SIDE_EFFECTS__
function $(...t) {
  return {
    ...t[0],
    pipe: t,
    get "~standard"() {
      return /* @__PURE__ */ v(this);
    },
    "~run"(e, n) {
      for (const r of t)
        if (r.kind !== "metadata") {
          if (e.issues && (r.kind === "schema" || r.kind === "transformation")) {
            e.typed = !1;
            break;
          }
          (!e.issues || !n.abortEarly && !n.abortPipeEarly) && (e = r["~run"](e, n));
        }
      return e;
    }
  };
}
function Mt(t) {
  return t.replace(/_[a-z]/g, (e) => e[1].toUpperCase());
}
function Tt(t) {
  return Object.entries(t).reduce((e, [n, r]) => (e[Mt(n)] = r, e), {});
}
function V(t) {
  const e = Tt(t);
  for (const n in e) {
    const r = e[n];
    r && typeof r == "object" && !(r instanceof Date) && (e[n] = Array.isArray(r) ? r.map(V) : V(r));
  }
  return e;
}
function oe(t) {
  return /* @__PURE__ */ x((e) => t ? V(e) : e);
}
function Ke(t) {
  return (e) => /* @__PURE__ */ $(
    t,
    oe(e)
  );
}
function It(t) {
  return (e, n) => Fe(
    /* @__PURE__ */ $(t, oe(n)),
    e
  );
}
function ie() {
  return /* @__PURE__ */ x(JSON.parse);
}
function ae(t) {
  const e = Ke(t);
  return (n) => /* @__PURE__ */ $(
    /* @__PURE__ */ d(),
    ie(),
    e(n)
  );
}
function Lt(t) {
  return /* @__PURE__ */ x((e) => {
    const n = {};
    return new URLSearchParams(e).forEach((r, s) => {
      const o = n[s];
      Array.isArray(o) ? o.push(r) : o === void 0 ? n[s] = r : n[s] = [o, r];
    }), Fe(t, n);
  });
}
function Ye(t) {
  return (e) => /* @__PURE__ */ $(
    /* @__PURE__ */ se([/* @__PURE__ */ d(), /* @__PURE__ */ ze(URLSearchParams)]),
    Lt(t),
    oe(e)
  );
}
const me = /* @__PURE__ */ y(/* @__PURE__ */ re(() => Nt())), Rt = /* @__PURE__ */ q({
  id: /* @__PURE__ */ C(),
  photo_url: /* @__PURE__ */ y(/* @__PURE__ */ d()),
  type: /* @__PURE__ */ d(),
  title: /* @__PURE__ */ d(),
  username: /* @__PURE__ */ y(/* @__PURE__ */ d())
}), Dt = /* @__PURE__ */ q({
  added_to_attachment_menu: /* @__PURE__ */ y(/* @__PURE__ */ I()),
  allows_write_to_pm: /* @__PURE__ */ y(/* @__PURE__ */ I()),
  first_name: /* @__PURE__ */ d(),
  id: /* @__PURE__ */ C(),
  is_bot: /* @__PURE__ */ y(/* @__PURE__ */ I()),
  is_premium: /* @__PURE__ */ y(/* @__PURE__ */ I()),
  last_name: /* @__PURE__ */ y(/* @__PURE__ */ d()),
  language_code: /* @__PURE__ */ y(/* @__PURE__ */ d()),
  photo_url: /* @__PURE__ */ y(/* @__PURE__ */ d()),
  username: /* @__PURE__ */ y(/* @__PURE__ */ d())
}), Wt = /* @__PURE__ */ q({
  auth_date: /* @__PURE__ */ $(
    /* @__PURE__ */ d(),
    /* @__PURE__ */ x((t) => new Date(Number(t) * 1e3)),
    /* @__PURE__ */ Je()
  ),
  can_send_after: /* @__PURE__ */ y(/* @__PURE__ */ $(/* @__PURE__ */ d(), /* @__PURE__ */ x(Number), /* @__PURE__ */ Ue())),
  chat: /* @__PURE__ */ y(/* @__PURE__ */ re(() => Ct())),
  chat_type: /* @__PURE__ */ y(/* @__PURE__ */ d()),
  chat_instance: /* @__PURE__ */ y(/* @__PURE__ */ d()),
  hash: /* @__PURE__ */ d(),
  query_id: /* @__PURE__ */ y(/* @__PURE__ */ d()),
  receiver: me,
  start_param: /* @__PURE__ */ y(/* @__PURE__ */ d()),
  signature: /* @__PURE__ */ d(),
  user: me
}), Ct = ae(Rt), Nt = ae(Dt), Ut = Ye(Wt);
function Ot(t) {
  return /^#[\da-f]{6}$/i.test(t);
}
const He = Ke(
  /* @__PURE__ */ Ge(
    /* @__PURE__ */ d(),
    /* @__PURE__ */ $(
      /* @__PURE__ */ se([/* @__PURE__ */ d(), /* @__PURE__ */ C()]),
      /* @__PURE__ */ x((t) => typeof t == "number" ? `#${(t & 16777215).toString(16).padStart(6, "0")}` : t),
      /* @__PURE__ */ Ne(Ot)
    )
  )
), z = /* @__PURE__ */ y(
  /* @__PURE__ */ $(/* @__PURE__ */ d(), /* @__PURE__ */ x((t) => t === "1"))
), ve = ae(He()), Jt = /* @__PURE__ */ q({
  tgWebAppBotInline: z,
  tgWebAppData: /* @__PURE__ */ y(Ut()),
  tgWebAppDefaultColors: /* @__PURE__ */ y(ve()),
  tgWebAppFullscreen: z,
  tgWebAppPlatform: /* @__PURE__ */ d(),
  tgWebAppShowSettings: z,
  tgWebAppStartParam: /* @__PURE__ */ y(/* @__PURE__ */ d()),
  tgWebAppThemeParams: ve(),
  tgWebAppVersion: /* @__PURE__ */ d()
}), Qe = Ye(Jt), ue = It(Qe()), Ze = /* @__PURE__ */ q({
  eventType: /* @__PURE__ */ d(),
  eventData: /* @__PURE__ */ y(/* @__PURE__ */ Be())
});
function Xe(t, e) {
  return e || (e = (n, r) => JSON.stringify(r)), new URLSearchParams(
    Object.entries(t).reduce((n, [r, s]) => (Array.isArray(s) ? n.push(...s.map((o) => [r, String(o)])) : s != null && n.push([
      r,
      s instanceof Date ? (s.getTime() / 1e3 | 0).toString() : typeof s == "string" || typeof s == "number" ? String(s) : typeof s == "boolean" ? s ? "1" : "0" : e(r, s)
    ]), n), [])
  ).toString();
}
function zt(t) {
  return Xe(t);
}
function Gt(t) {
  return Xe(t, (e, n) => e === "tgWebAppData" ? zt(n) : JSON.stringify(n));
}
function Ve(t) {
  try {
    return /* @__PURE__ */ qt(Qe(), t);
  } catch {
    return !1;
  }
}
function Bt(t) {
  return { all: t = t || /* @__PURE__ */ new Map(), on: function(e, n) {
    var r = t.get(e);
    r ? r.push(n) : t.set(e, [n]);
  }, off: function(e, n) {
    var r = t.get(e);
    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : t.set(e, []));
  }, emit: function(e, n) {
    var r = t.get(e);
    r && r.slice().map(function(s) {
      s(n);
    }), (r = t.get("*")) && r.slice().map(function(s) {
      s(e, n);
    });
  } };
}
function Ft(t, e) {
  const n = Bt(), r = /* @__PURE__ */ new Map(), s = (o, i, a) => {
    a || (a = !1);
    const u = r.get(o) || /* @__PURE__ */ new Map();
    r.set(o, u);
    const c = u.get(i) || [];
    u.set(i, c);
    const p = c.findIndex((l) => l[1] === a);
    p >= 0 && (n.off(o, c[p][0]), c.splice(p, 1), !c.length && u.delete(i), u.size || (r.delete(o), !r.size && e()));
  };
  return [
    function(i, a, u) {
      !r.size && t();
      function c() {
        s(i, a, u);
      }
      function p(...b) {
        u && c(), i === "*" ? a(b) : a(...b);
      }
      n.on(i, p);
      const l = r.get(i) || /* @__PURE__ */ new Map();
      r.set(i, l);
      const _ = l.get(a) || [];
      return l.set(a, _), _.push([p, u || !1]), c;
    },
    s,
    // eslint-disable-next-line @typescript-eslint/unbound-method
    n.emit,
    function() {
      const i = n.all.size;
      n.all.clear(), r.clear(), i && e();
    }
  ];
}
function ge(t, e) {
  window.dispatchEvent(new MessageEvent("message", {
    data: JSON.stringify({ eventType: t, eventData: e }),
    // We specify window.parent to imitate the case, the parent iframe sent us this event.
    source: window.parent
  }));
}
let D = !1;
const [ce, Kt] = /* @__PURE__ */ $t("Bridge", {
  bgColor: "#9147ff",
  textColor: "white",
  shouldLog() {
    return D;
  }
}), we = (t) => {
  ce(!1, "Event received:", t);
};
function Yt(t) {
  t !== D && (D = t, D ? et("*", we) : Qt("*", we));
}
const Ht = {
  clipboard_text_received: /* @__PURE__ */ g({
    req_id: /* @__PURE__ */ k(),
    data: /* @__PURE__ */ T(/* @__PURE__ */ k())
  }),
  custom_method_invoked: /* @__PURE__ */ g({
    req_id: /* @__PURE__ */ k(),
    result: /* @__PURE__ */ K(/* @__PURE__ */ Ae()),
    error: /* @__PURE__ */ K(/* @__PURE__ */ k())
  }),
  popup_closed: /* @__PURE__ */ T(
    /* @__PURE__ */ g({ button_id: /* @__PURE__ */ T(/* @__PURE__ */ k(), () => {
    }) }),
    {}
  ),
  viewport_changed: /* @__PURE__ */ g({
    height: /* @__PURE__ */ F(),
    width: /* @__PURE__ */ T(/* @__PURE__ */ F(), () => window.innerWidth),
    is_state_stable: /* @__PURE__ */ B(),
    is_expanded: /* @__PURE__ */ B()
  }),
  theme_changed: /* @__PURE__ */ g({
    theme_params: He()
  })
};
function Ee(t) {
  if (t.source !== window.parent)
    return;
  let e;
  try {
    e = Y(/* @__PURE__ */ qe(/* @__PURE__ */ k(), ie(), Ze), t.data);
  } catch {
    return;
  }
  const { eventType: n, eventData: r } = e, s = Ht[n];
  try {
    const o = s ? Y(s, r) : r;
    Zt(n, o);
  } catch (o) {
    Kt(
      !0,
      [
        `An error occurred processing the "${n}" event from the Telegram application.`,
        "Please, file an issue here:",
        "https://github.com/Telegram-Mini-Apps/telegram-apps/issues/new/choose"
      ].join(`
`),
      e,
      o
    );
  }
}
const [
  et,
  Qt,
  Zt,
  Xt
] = Ft(
  () => {
    const t = window, e = { receiveEvent: ge };
    t.TelegramGameProxy_receiveEvent = ge, t.TelegramGameProxy = e, t.Telegram = { WebView: e }, window.addEventListener("message", Ee);
  },
  () => {
    ["TelegramGameProxy_receiveEvent", "TelegramGameProxy", "Telegram"].forEach((t) => {
      delete window[t];
    }), window.removeEventListener("message", Ee);
  }
);
var Vt = Object.defineProperty, en = (t, e, n) => e in t ? Vt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, tn = (t, e, n) => en(t, e + "", n);
function tt(t) {
  return (e) => e instanceof t;
}
function M(t, e) {
  e || (e = []);
  class n extends Error {
    constructor(...s) {
      const o = typeof e == "function" ? e(...s) : typeof e == "string" ? [e] : e || [];
      super(...o), this.name = t;
    }
  }
  return Object.defineProperty(n, "name", { value: t }), [n, tt(n)];
}
function nn(t, e, n) {
  class r extends M(t, n)[0] {
    constructor(...o) {
      super(...o), tn(this, "data"), this.data = e(...o);
    }
  }
  return Object.defineProperty(r, "name", { value: t }), [r, tt(r)];
}
const [
  rn,
  vn
] = M(
  "MethodUnsupportedError",
  (t, e) => [
    `Method "${t}" is unsupported in Mini Apps version ${e}`
  ]
), [
  sn,
  gn
] = M(
  "MethodParameterUnsupportedError",
  (t, e, n) => [
    `Parameter "${e}" of "${t}" method is unsupported in Mini Apps version ${n}`
  ]
), [
  on,
  wn
] = nn(
  "LaunchParamsRetrieveError",
  (t) => ({ errors: t }),
  (t) => [
    [
      "Unable to retrieve launch parameters from any known source. Perhaps, you have opened your app outside Telegram?",
      "📖 Refer to docs for more information:",
      "https://docs.telegram-mini-apps.com/packages/telegram-apps-bridge/environment",
      "",
      "Collected errors:",
      ...t.map(([e, n]) => `Source: ${e} / ${n instanceof Error ? n.message : String(n)}`)
    ].join(`
`)
  ]
), [
  an,
  En
] = M(
  "InvalidLaunchParamsError",
  (t, e) => [
    `Invalid value for launch params: ${t}`,
    { cause: e }
  ]
), [un, kn] = M("UnknownEnvError"), [
  cn,
  xn
] = M(
  "InvokeCustomMethodError",
  (t) => [`Server returned error: ${t}`]
);
function pn(t, e) {
  e();
}
// @__NO_SIDE_EFFECTS__
function nt(t, e) {
  e || (e = {});
  const n = e.equals || Object.is;
  let r = [], s = t;
  const o = (c) => {
    if (!n(s, c)) {
      const p = s;
      s = c, pn(u, () => {
        [...r].forEach(([l, _]) => {
          l(c, p), _ && a(l, !0);
        });
      });
    }
  };
  function i(c) {
    const p = typeof c != "object" ? { once: c } : c;
    return {
      once: p.once || !1,
      signal: p.signal || !1
    };
  }
  const a = (c, p) => {
    const l = i(p), _ = r.findIndex(([b, P]) => b === c && P.once === l.once && P.signal === l.signal);
    _ >= 0 && r.splice(_, 1);
  }, u = Object.assign(
    function() {
      return ln(u), s;
    },
    {
      destroy() {
        r = [];
      },
      set: o,
      reset() {
        o(t);
      },
      sub(c, p) {
        return r.push([c, i(p)]), () => a(c, p);
      },
      unsub: a,
      unsubAll() {
        r = r.filter((c) => c[1].signal);
      }
    }
  );
  return u;
}
const G = [];
function ln(t) {
  G.length && G[G.length - 1].add(t);
}
const L = /* @__PURE__ */ nt((...t) => window.parent.postMessage(...t)), fn = (...t) => L()(...t), rt = /* @__PURE__ */ nt("https://web.telegram.org");
function st(t, e) {
  ce(!1, "Posting event:", e ? { eventType: t, eventData: e } : { eventType: t });
  const n = window, r = JSON.stringify({ eventType: t, eventData: e });
  if (Te())
    return fn(r, rt());
  if (Me(n)) {
    n.TelegramWebviewProxy.postEvent(t, JSON.stringify(e));
    return;
  }
  if (/* @__PURE__ */ W(/* @__PURE__ */ g({ external: /* @__PURE__ */ g({ notify: /* @__PURE__ */ te() }) }), n)) {
    n.external.notify(r);
    return;
  }
  throw new un();
}
function ot(t, e, n) {
  n || (n = {});
  const { capture: r } = n, [s, o] = xt();
  return new ne((i) => {
    (Array.isArray(e) ? e : [e]).forEach((a) => {
      s(
        et(a, (u) => {
          (!r || (Array.isArray(e) ? r({
            event: a,
            payload: u
          }) : r(u))) && i(u);
        })
      );
    }), (n.postEvent || st)(t, n.params);
  }, n).finally(o);
}
const ke = "launchParams";
function xe(t) {
  return t.replace(/^[^?#]*[?#]/, "").replace(/[?#]/g, "&");
}
function it() {
  const t = [];
  for (const [e, n] of [
    // Try to retrieve launch parameters from the current location. This method can return
    // nothing in case, location was changed, and then the page was reloaded.
    [() => xe(window.location.href), "window.location.href"],
    // Then, try using the lower level API - window.performance.
    [() => {
      const r = performance.getEntriesByType("navigation")[0];
      return r && xe(r.name);
    }, "performance navigation entries"],
    [() => kt(ke), "local storage"]
  ]) {
    const r = e();
    if (!r) {
      t.push([n, new Error("Source is empty")]);
      continue;
    }
    if (Ve(r))
      return De(ke, r), r;
    try {
      ue(r);
    } catch (s) {
      t.push([n, s]);
    }
  }
  throw new on(t);
}
function dn(t) {
  const e = ue(it());
  return t ? X(e) : e;
}
function $n(t, e) {
  if (!t)
    try {
      return dn(), !0;
    } catch {
      return !1;
    }
  return ne.fn(async (n) => {
    if (Me(window))
      return !0;
    try {
      return await ot("web_app_request_theme", "theme_changed", n), !0;
    } catch {
      return !1;
    }
  }, e || { timeout: 100 });
}
function Pn({ launchParams: t, onEvent: e, resetPostMessage: n } = {}) {
  if (t) {
    const o = typeof t == "string" || t instanceof URLSearchParams ? t.toString() : (
      // Here we have to trick serializeLaunchParamsQuery into thinking, it serializes a valid
      // value. We are doing it because we are working with tgWebAppData presented as a
      // string, not an object as serializeLaunchParamsQuery requires.
      Gt({ ...t, tgWebAppData: void 0 }) + (t.tgWebAppData ? `&tgWebAppData=${encodeURIComponent(t.tgWebAppData.toString())}` : "")
    );
    if (!Ve(o))
      try {
        ue(o);
      } catch (i) {
        throw new an(o, i);
      }
    De("launchParams", o);
  }
  if (Te()) {
    if (!e)
      return;
    const o = /* @__PURE__ */ qe(
      /* @__PURE__ */ k(),
      ie(),
      Ze
    );
    n && L.reset();
    const i = L();
    L.set((...a) => {
      const [u] = a, c = () => {
        i(...a);
      };
      if (/* @__PURE__ */ W(o, u)) {
        const p = Y(o, u);
        e([p.eventType, p.eventData], c);
      } else
        c();
    });
    return;
  }
  const r = window.TelegramWebviewProxy || {}, s = r.postEvent || (() => {
  });
  window.TelegramWebviewProxy = {
    ...r,
    postEvent(o, i) {
      const a = () => {
        s(o, i);
      };
      e ? e([o, i ? JSON.parse(i) : void 0], a) : a();
    }
  }, ce(!1, "Environment was mocked by the mockTelegramEnv function");
}
function Sn() {
  return new URLSearchParams(it()).get("tgWebAppData") || void 0;
}
function yn(t) {
  return ({ req_id: e }) => e === t;
}
function $e(t) {
  return t.split(".").map(Number);
}
function _n(t, e) {
  const n = $e(t), r = $e(e), s = Math.max(n.length, r.length);
  for (let o = 0; o < s; o += 1) {
    const i = n[o] || 0, a = r[o] || 0;
    if (i !== a)
      return i > a ? 1 : -1;
  }
  return 0;
}
function h(t, e) {
  return _n(t, e) <= 0;
}
function Pe(t, e, n) {
  if (typeof n == "string") {
    if (t === "web_app_open_link") {
      if (e === "try_instant_view")
        return h("6.4", n);
      if (e === "try_browser")
        return h("7.6", n);
    }
    if (t === "web_app_set_header_color" && e === "color")
      return h("6.9", n);
    if (t === "web_app_close" && e === "return_back")
      return h("7.6", n);
    if (t === "web_app_setup_main_button" && e === "has_shine_effect")
      return h("7.10", n);
  }
  switch (t) {
    case "web_app_open_tg_link":
    case "web_app_open_invoice":
    case "web_app_setup_back_button":
    case "web_app_set_background_color":
    case "web_app_set_header_color":
    case "web_app_trigger_haptic_feedback":
      return h("6.1", e);
    case "web_app_open_popup":
      return h("6.2", e);
    case "web_app_close_scan_qr_popup":
    case "web_app_open_scan_qr_popup":
    case "web_app_read_text_from_clipboard":
      return h("6.4", e);
    case "web_app_switch_inline_query":
      return h("6.7", e);
    case "web_app_invoke_custom_method":
    case "web_app_request_write_access":
    case "web_app_request_phone":
      return h("6.9", e);
    case "web_app_setup_settings_button":
      return h("6.10", e);
    case "web_app_biometry_get_info":
    case "web_app_biometry_open_settings":
    case "web_app_biometry_request_access":
    case "web_app_biometry_request_auth":
    case "web_app_biometry_update_token":
      return h("7.2", e);
    case "web_app_setup_swipe_behavior":
      return h("7.7", e);
    case "web_app_share_to_story":
      return h("7.8", e);
    case "web_app_setup_secondary_button":
    case "web_app_set_bottom_bar_color":
      return h("7.10", e);
    case "web_app_request_safe_area":
    case "web_app_request_content_safe_area":
    case "web_app_request_fullscreen":
    case "web_app_exit_fullscreen":
    case "web_app_set_emoji_status":
    case "web_app_add_to_home_screen":
    case "web_app_check_home_screen":
    case "web_app_request_emoji_status_access":
    case "web_app_check_location":
    case "web_app_open_location_settings":
    case "web_app_request_file_download":
    case "web_app_request_location":
    case "web_app_send_prepared_message":
    case "web_app_start_accelerometer":
    case "web_app_start_device_orientation":
    case "web_app_start_gyroscope":
    case "web_app_stop_accelerometer":
    case "web_app_stop_device_orientation":
    case "web_app_stop_gyroscope":
    case "web_app_toggle_orientation_lock":
      return h("8.0", e);
    default:
      return [
        "iframe_ready",
        "iframe_will_reload",
        "web_app_close",
        "web_app_data_send",
        "web_app_expand",
        "web_app_open_link",
        "web_app_ready",
        "web_app_request_theme",
        "web_app_request_viewport",
        "web_app_setup_main_button",
        "web_app_setup_closing_behavior"
      ].includes(t);
  }
}
function jn(t, e) {
  e || (e = "strict");
  const n = typeof e == "function" ? e : (r) => {
    const { method: s, version: o } = r, i = "param" in r ? new sn(s, r.param, o) : new rn(s, o);
    if (e === "strict")
      throw i;
    return console.warn(i.message);
  };
  return (r, s) => Pe(r, t) ? r === "web_app_set_header_color" && /* @__PURE__ */ W(/* @__PURE__ */ g({ color: /* @__PURE__ */ je() }), s) && !Pe(r, "color", t) ? n({ version: t, method: r, param: "color" }) : st(r, s) : n({ version: t, method: r });
}
function An(t, e, n, r) {
  return ot("web_app_invoke_custom_method", "custom_method_invoked", {
    ...r || {},
    params: { method: t, params: e, req_id: n },
    capture: yn(n)
  }).then(({ result: s, error: o }) => {
    if (o)
      throw new cn(o);
    return s;
  });
}
function qn() {
  Xt(), Yt(!1), [L, rt].forEach((t) => {
    t.unsubAll(), t.reset();
  });
}
export {
  ne as AbortablePromise,
  mt as CancelledError,
  an as InvalidLaunchParamsError,
  cn as InvokeCustomMethodError,
  on as LaunchParamsRetrieveError,
  mn as ManualPromise,
  sn as MethodParameterUnsupportedError,
  rn as MethodUnsupportedError,
  vt as TimeoutError,
  un as UnknownEnvError,
  yn as captureSameReq,
  _n as compareVersions,
  jn as createPostEvent,
  ge as emitEvent,
  Me as hasWebviewProxy,
  An as invokeCustomMethod,
  bn as isCancelledError,
  Te as isIframe,
  En as isInvalidLaunchParamsError,
  xn as isInvokeCustomMethodError,
  wn as isLaunchParamsRetrieveError,
  gn as isMethodMethodParameterUnsupportedError,
  vn as isMethodUnsupportedError,
  $n as isTMA,
  hn as isTimeoutError,
  kn as isUnknownEnvError,
  Pn as mockTelegramEnv,
  Qt as off,
  Xt as offAll,
  et as on,
  st as postEvent,
  fn as postMessage,
  L as postMessageImplementation,
  ot as request,
  qn as resetPackageState,
  dn as retrieveLaunchParams,
  Sn as retrieveRawInitData,
  it as retrieveRawLaunchParams,
  Yt as setDebug,
  Pe as supports,
  rt as targetOrigin
};
//# sourceMappingURL=index.js.map
